import React from "react";
import {
  Card,
  CardActions,
  CardHeader,
  CardContent,
  makeStyles,
  Typography,
  Grid,
  Button,
  List,
  ListItem,
  ListItemText,
} from "@material-ui/core";

import { WebTracker } from "../../types";
import DownloadLatestReportButton from "../../DownloadLatestReportButton";
import { getExtraStepsToUninstallTracker } from "./FollowUpTaskExtraSteps";

const useStyles = makeStyles((theme) => ({
  card: {
    position: "relative",
    minWidth: 500,
    maxWidth: 600,
    paddingTop: 0,
    paddingBottom: 0,
  },
  cardActions: {
    alignContent: "center",
    justifyContent: "right",
    marginTop: theme.spacing(1),
  },
  cancelBtn: {
    marginRight: theme.spacing(2),
  },
  subTitle: {
    marginTop: theme.spacing(1.8),
  },
  listItem: {
    padding: 0,
  },
  indentedListItem: {
    padding: 0,
    paddingLeft: theme.spacing(2),
  },
}));

export type SetupVideoProxyProps = {
  onClose: () => void;
  tracker: WebTracker;
};

function SetupVideoProxy({ onClose, tracker }: SetupVideoProxyProps) {
  const classes = useStyles();

  const extraSteps = getExtraStepsToUninstallTracker(tracker.name);

  return (
    <Card className={classes.card}>
      <CardHeader
        disableTypography
        title={
          <Typography component="h5" variant="h5">
            Uninstall {tracker.name}
          </Typography>
        }
        subheader={
          <Typography
            className={classes.subTitle}
            component="p"
            variant="subtitle2"
          >
            {tracker.name} was detected in the latest scan of your site.
            Complete the following steps to uninstall {tracker.name}.
          </Typography>
        }
      />
      <CardContent className={classes.card}>
        <Grid container className={classes.card}>
          <Grid item>
            <List className="p-0">
              {extraSteps.map((step, index) => (
                <ListItem
                  key={`tracker-resolution-extra-step-${index}`}
                  className={classes.indentedListItem}
                >
                  <ListItemText primary={[`${index + 1}.  `, step]} />
                </ListItem>
              ))}
            </List>
          </Grid>
          <Grid>
            <Typography
              className={classes.subTitle}
              component="p"
              variant="subtitle2"
            >
              &#9432; Note that this action item won't be considered completed
              until Freshpaint confirms there are no more occurrences of{" "}
              {tracker.name} on your site during the next scheduled scan.
            </Typography>
          </Grid>
        </Grid>
      </CardContent>
      <CardActions>
        <Grid container className={classes.cardActions}>
          <Grid item alignItems="flex-end">
            <Button
              className={classes.cancelBtn}
              variant="text"
              color="secondary"
              onClick={onClose}
              size="small"
              title="OK"
            >
              Got It
            </Button>
          </Grid>
          <Grid item alignItems="flex-end">
            <DownloadLatestReportButton />
          </Grid>
        </Grid>
      </CardActions>
    </Card>
  );
}

export default SetupVideoProxy;
